/* eslint-disable */
// CSS
import "../sass/index.sass";
// JS
import { gsap } from "gsap";

// 網頁資料下載完成
document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('a-scene').setAttribute('load-complete', '');
    // VR判斷
    (function () {
        let vrButton = document.getElementById("enterVRBtn");
        if (navigator.xr) {
            navigator.xr.isSessionSupported("immersive-vr").then(supported => {
                vrButton.style.display = supported ? "block" : "none";
            }).catch(error => {
                vrButton.style.display = "none";
            });
        } else {
            vrButton.style.display = "none";
        }
    })();
});

// 3D資源下載完成
AFRAME.registerComponent("load-complete", {
    init: function () {
        let loading = document.querySelector("div.loading");
        // gsap.to(loading, { opacity: 0, ease: "power3.inOut", overwrite: true, duration: 2 });

        function showLoading() {
            loading.style.opacity = "1";
            loading.style.display = "flex";
        }
        
        function hideLoading() {
            gsap.to(".loading", { opacity: 0, duration: 0.5, onComplete: () => {
                loading.style.display = "none";
            }});
        }
        // hideLoading();

        document.querySelector("a-scene").addEventListener("loaded", function () {
            const totalButtons =24;
            let skySphere = document.getElementById("skySphere");
            let characterPlane = document.getElementById("characterPlane");
            const btnContainer = document.getElementById("btnContainer");
            const radius = 0.24;
            const startAngle = Math.PI / 2;
            let buttonPositions = [];


            function debugLog(msg) {
                const debugEl = document.getElementById("debugText");
                if (debugEl) {
                    debugEl.setAttribute("text", "value", msg);
                }
            }

            // 抓取HASH值
            function getHashIndex() {
                let hash = window.location.hash;
                let index = parseInt(hash.replace("#", ""));
                if (isNaN(index) || index < 1 || index > totalButtons) {
                    index = 1; // 預設為 1
                    window.location.hash = "#1"; // 設定預設 HASH
                }
                return index;
            }
            
            // 初始設定 selectedIndex
            let selectedIndex = getHashIndex();
            updateSelectionByHash();




            // 水平排列的按鈕
for (let i = 1; i <= totalButtons; i++) {
    let plane = document.createElement("a-plane");
    plane.setAttribute("class", "btnPlane");
    plane.setAttribute("width", "0.1");
    plane.setAttribute("height", "0.1");
    plane.setAttribute("material", `src: images/character/b${i}.png; transparent: true;`);

    // 水平排列：以 selectedIndex 為中心，預設先排好位置
    let offset = i - selectedIndex;
    let spacing = 0.12;
    let x = offset * spacing;
    let y = 0.15;
    let z = 0;

    plane.setAttribute("position", { x, y, z });
    btnContainer.appendChild(plane);
    buttonPositions.push({ index: i, x: x, y: y, z: z });
}



            // // VR 按鈕設定
            // for (let i = 1; i <= totalButtons; i++) {
            //     let plane = document.createElement("a-plane");
            //     plane.setAttribute("class", "btnPlane");
            //     plane.setAttribute("width", "0.05");
            //     plane.setAttribute("height", "0.05");
            //     plane.setAttribute("material", "src: images/character/b" + i + ".png; transparent: true;");
            //     // 計算圓形座標
            //     let angle = startAngle + (i - 1) * (2 * Math.PI / totalButtons);
            //     let x = Math.cos(angle) * radius;
            //     let y = Math.sin(angle) * radius;
            //     let z = 0.05;
            //     plane.setAttribute("position", x + " " + y + " " + z);
            //     btnContainer.appendChild(plane);
            //     buttonPositions.push({ x: x, y: y, z: z });
            // }



            // 等待按鈕生成完再抓取
            let buttons = document.querySelectorAll(".btnPlane");

            // 更新按鈕狀態
            function updateButtonState() {
    buttons.forEach((button, index) => {
        const btnIndex = index + 1;
        const offset = btnIndex - selectedIndex;
        const spacing = 0.12;

        const targetX = offset * spacing;

        // 透明度判斷
        let absOffset = Math.abs(offset);
        let targetOpacity = 0;
        if (absOffset === 0) {
            targetOpacity = 1;
        } else if (absOffset === 1) {
            targetOpacity = 0.5;
        } else if (absOffset === 2) {
            targetOpacity = 0.25;
        }

        // ✅ 設定 A-Frame animation__move（改位置）
        button.setAttribute('animation__move', {
            property: 'object3D.position.x',
            to: targetX,
            dur: 400,
            easing: 'easeOutQuad'
        });

        // ✅ 設定 A-Frame animation__fade（改透明度）
        button.setAttribute('animation__fade', {
            property: 'components.material.material.opacity',
            to: targetOpacity,
            dur: 400,
            easing: 'easeOutQuad'
        });

        // ✅ 確保透明屬性開啟，不然動畫無效
        button.setAttribute('material', {
            transparent: true
        });
    });
}





            // HASH 值偵聽
            window.addEventListener("hashchange", function () { updateSelectionByHash(); });

            function updateSelectionByHash() {
                selectedIndex = getHashIndex();
                let newCharacterSrc = "images/character/p" + selectedIndex + ".png";
                let newSkySrc = "images/bg/bg" + selectedIndex + ".jpg";
            
                showLoading(); // 顯示 Loading
            
                let img1 = new Image();
                let img2 = new Image();
                let loadedCount = 0;
            
                function checkAllImagesLoaded() {
                    loadedCount++;
                    if (loadedCount === 2) {
                        // 設定材質後，監聽貼圖完成
                        let characterLoaded = false;
                        let skyLoaded = false;
            
                        function tryHideLoading() {
                            if (characterLoaded && skyLoaded) {
                                updateButtonState();
                                hideLoading(); // 確認兩者都貼圖完成後再隱藏
                            }
                        }
            
                        // 監聽角色貼圖完成
                        characterPlane.addEventListener("materialtextureloaded", function onCharLoad() {
                            characterPlane.removeEventListener("materialtextureloaded", onCharLoad);
                            characterLoaded = true;
                            tryHideLoading();
                        });
            
                        // 監聽背景貼圖完成
                        skySphere.addEventListener("materialtextureloaded", function onSkyLoad() {
                            skySphere.removeEventListener("materialtextureloaded", onSkyLoad);
                            skyLoaded = true;
                            tryHideLoading();
                        });
            
                        // 設定材質 → 開始貼圖
                        characterPlane.setAttribute("material", "src: " + newCharacterSrc);
                        skySphere.setAttribute("material", "src: " + newSkySrc);
                    }
                }
            
                img1.onload = checkAllImagesLoaded;
                img2.onload = checkAllImagesLoaded;
                img1.src = newCharacterSrc;
                img2.src = newSkySrc;
            }
            




            
            

            






            // 滾輪控制 FOV
            let camera = document.getElementById("basic_camera");
            let minFov = 30;  // 最小視野（放大）
            let maxFov = 100; // 最大視野（縮小）
            let zoomSpeed = 2; // 滾輪縮放速度
            
            document.addEventListener("wheel", function (event) {
                event.preventDefault(); // 防止頁面滾動
                let currentFov = parseFloat(camera.getAttribute("fov")) || 80;
                if (event.deltaY > 0) {
                    // 滾輪向下（放大視角）
                    currentFov = Math.min(currentFov + zoomSpeed, maxFov);
                } else {
                    // 滾輪向上（縮小視角）
                    currentFov = Math.max(currentFov - zoomSpeed, minFov);
                }
                camera.setAttribute("fov", currentFov);
                //console.log("FOV 更新為:", currentFov);
            }, { passive: false });

            document.getElementById("enterVRBtn").addEventListener("click", function () {
                let scene = document.querySelector("a-scene");
                if (scene) {
                    scene.enterVR();





                    let leftController = document.querySelector("a-entity[oculus-touch-controls='hand: left']");
                    
                    // 如果有 VR 功能則則
                    if (leftController) {
                        let canSwitch = true; // 防止連續切換
                        leftController.addEventListener("axismove", function (event) {
                            let x = event.detail.axis[2] || 0; 
                            debugLog(x);
                            let threshold = 0.5;
                            if (x > threshold && canSwitch) {
                                let newIndex = selectedIndex - 1;
                                if (newIndex < 1) newIndex = totalButtons;
                                canSwitch = false;
                                window.location.hash = "#" + newIndex; // 改 hash，自動觸發更新
                            } else if (x < -threshold && canSwitch) {
                                let newIndex = selectedIndex + 1;
                                if (newIndex > totalButtons) newIndex = 1;
                                canSwitch = false;
                                window.location.hash = "#" + newIndex;
                            } else if (Math.abs(x) < 0.2) {
                                canSwitch = true;
                            }
                            
                        });
                    }






                }
                skySphere.setAttribute("position", "0 2 0");
                characterPlane.setAttribute("position", "0 1 -1.2");
            });

            document.getElementById("nextBgBtn").addEventListener("click", function () {
                selectedIndex++;
                if (selectedIndex > totalButtons) selectedIndex = 1;
                window.location.hash = "#" + selectedIndex; // 改變 HASH，自動觸發更新
            });

            document.getElementById("prevBgBtn").addEventListener("click", function () {
                selectedIndex--;
                if (selectedIndex < 1) selectedIndex = totalButtons;
                window.location.hash = "#" + selectedIndex; // 改變 HASH，自動觸發更新
            });

            updateButtonState(); // **初始按鈕狀態**



            // 手機雙指縮放控制
            let lastTouchDistance = null;

            document.addEventListener("touchmove", function (event) {
                if (event.touches.length === 2) {
                    event.preventDefault(); // 防止捲動

                    let touch1 = event.touches[0];
                    let touch2 = event.touches[1];

                    let dx = touch2.clientX - touch1.clientX;
                    let dy = touch2.clientY - touch1.clientY;
                    let currentDistance = Math.sqrt(dx * dx + dy * dy);

                    if (lastTouchDistance !== null) {
                        let delta = currentDistance - lastTouchDistance;

                        // 這裡根據手勢距離改變 FOV
                        let currentFov = parseFloat(camera.getAttribute("fov")) || 80;
                        let newFov = currentFov - delta * 0.5;  // 0.05 可調整縮放靈敏度

                        // 限制範圍
                        newFov = Math.max(minFov, Math.min(maxFov, newFov));
                        camera.setAttribute("fov", newFov);
                        //console.log("FOV (pinch) 更新為:", newFov);
                    }

                    lastTouchDistance = currentDistance;
                }
            }, { passive: false });

            document.addEventListener("touchend", function (event) {
                if (event.touches.length < 2) {
                    lastTouchDistance = null; // 重置
                }
            });



            




const isMobile = /Mobi|Android/i.test(navigator.userAgent);
const isVRSupported = AFRAME.utils.device.checkHeadsetConnected();


if (!isVRSupported && !isMobile) {

// ✅ 可調整參數 —— 全集中在這裡
const idleTimeoutSeconds = 20;         // 無操作多久開始自動 (秒)
const rotationDuration = 40000;       // 一圈時間 (毫秒)
const oscillationAmplitude = 5;       // 垂直擺動最大角度 ± (度)
const oscillationSpeed = 0.1;         // 擺動速度倍率（越大越快）

// ✅ 狀態變數
let isAuto = false;
let idleTimer = null;
let lastMouseTime = Date.now();
let cameraYaw = 0;
let oscillationPhase = 0;
let lastTimestamp = null;
let circleAccumulator = 0;

const sceneEl = document.querySelector("a-scene");
const camRig = document.getElementById("cameraRig");
const camEl = document.querySelector("#basic_camera");

// ✅ 滑鼠移動監聽：重設計時器與停止動畫
document.addEventListener("mousemove", () => {
  lastMouseTime = Date.now();
  if (isAuto) stopAutoRotate();
  startIdleTimer();
});

// ✅ 啟動 idle 計時器
function startIdleTimer() {
  clearTimeout(idleTimer);
  if (!sceneEl.is("vr-mode")) {
    idleTimer = setTimeout(() => {
      isAuto = true;
      lastTimestamp = null;
      circleAccumulator = 0;
      requestAnimationFrame(autoUpdate);
    }, idleTimeoutSeconds * 1000);
  }
}

// ✅ 停止自動動畫
function stopAutoRotate() {
  isAuto = false;
}

// ✅ 自動旋轉 & 擺動主動畫
function autoUpdate(ts) {
  if (!isAuto) return;
  if (!lastTimestamp) lastTimestamp = ts;
  const delta = ts - lastTimestamp;
  lastTimestamp = ts;

  // 累加旋轉角度
  let deltaYaw = 360 * delta / rotationDuration;
  cameraYaw = (cameraYaw + deltaYaw) % 360;

  // 累積一圈後切換下一張圖
  circleAccumulator += deltaYaw;
  if (circleAccumulator >= 360) {
    circleAccumulator -= 360;
    selectedIndex = (selectedIndex % totalButtons) + 1;
    window.location.hash = "#" + selectedIndex;
  }

  // 上下擺動計算（使用 sin）
  oscillationPhase += delta / 1000 * oscillationSpeed;
  const pitch = Math.sin(oscillationPhase * Math.PI) * oscillationAmplitude;

  if (!sceneEl.is("vr-mode") && camRig) {
    camRig.setAttribute("rotation", { x: pitch, y: cameraYaw, z: 0 });
  }

  requestAnimationFrame(autoUpdate);
}

// ✅ VR 模式切換監聽
sceneEl.addEventListener("enter-vr", stopAutoRotate);
sceneEl.addEventListener("exit-vr", startIdleTimer);

// ✅ 啟動
startIdleTimer();

}







        
const infoBtn = document.querySelector(".info_btn");
  const aboutBox = document.querySelector(".about_genxr");
  const closeBtn = document.querySelector(".about_genxr .close_btn");

  // 預設隱藏
  aboutBox.style.display = "none";

  // 打開
  infoBtn.addEventListener("click", () => {
    aboutBox.style.display = "flex";
  });

  // 關閉
  closeBtn.addEventListener("click", () => {
    aboutBox.style.display = "none";
  });









        });
    }
});
